import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import authHeaderV2 from "../services/auth-header-v2";

interface CreatePaymentRequest {
  amount: number;
}

interface CreatePaymentResponse {
  transactionId: string;
  qrcode: string;
  code: string;
}

export const createPayment = async (
  data: CreatePaymentRequest
): Promise<any> => {
  const response = await axios.post<CreatePaymentResponse>(
    `https://financial-api.ms.leveai.com.br/user-business/payments/code`,
    data,
    {
      headers: authHeaderV2(),
    }
  );
  return response.data;
};

export const useCreatePayment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createPayment,
    onSuccess: () => {},
    onSettled: async () => {
      return await queryClient.invalidateQueries({
        queryKey: ["payments"],
      });
    },
  });
};
